// ============================================
// META PIXEL ID
// ============================================
const META_PIXEL_ID = '2288111705033398'

// Base Hotmart checkout URL
const HOTMART_BASE_URL = 'https://pay.hotmart.com/N104821626W'
const HOTMART_OFFER = 'diav4y78'
const DEFAULT_SCK = 'unstoppable_brain_organic'

// Product info for events
const PRODUCT = {
  name: 'The Unstoppable Brain',
  value: 6.97,
  currency: 'USD',
  contentType: 'product',
}

// ============================================
// COOKIE HELPERS
// ============================================
function getCookie(name: string): string | null {
  try {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? decodeURIComponent(match[2]) : null
  } catch {
    return null
  }
}

// ============================================
// UTM HELPERS
// ============================================
interface UTMParams {
  utm_source: string | null
  utm_medium: string | null
  utm_campaign: string | null
  utm_content: string | null
  utm_term: string | null
  fbclid: string | null
}

function getUTMParams(): UTMParams {
  try {
    const params = new URLSearchParams(window.location.search)
    return {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_content: params.get('utm_content'),
      utm_term: params.get('utm_term'),
      fbclid: params.get('fbclid'),
    }
  } catch {
    return {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_content: null,
      utm_term: null,
      fbclid: null,
    }
  }
}

function buildSCK(utms: UTMParams): string {
  const parts = [
    utms.utm_source,
    utms.utm_medium,
    utms.utm_campaign,
    utms.utm_content,
    utms.utm_term,
  ].filter(Boolean)

  return parts.length > 0 ? parts.join('|') : DEFAULT_SCK
}

// ============================================
// CHECKOUT URL BUILDER
// ============================================
export function buildCheckoutURL(): string {
  try {
    const utms = getUTMParams()
    const sck = buildSCK(utms)
    const fbp = getCookie('_fbp')
    const fbc = getCookie('_fbc')

    const url = new URL(HOTMART_BASE_URL)
    url.searchParams.set('off', HOTMART_OFFER)

    // Forward individual UTMs
    if (utms.utm_source) url.searchParams.set('utm_source', utms.utm_source)
    if (utms.utm_medium) url.searchParams.set('utm_medium', utms.utm_medium)
    if (utms.utm_campaign)
      url.searchParams.set('utm_campaign', utms.utm_campaign)
    if (utms.utm_content) url.searchParams.set('utm_content', utms.utm_content)
    if (utms.utm_term) url.searchParams.set('utm_term', utms.utm_term)
    if (utms.fbclid) url.searchParams.set('fbclid', utms.fbclid)

    // SCK/SRC for Hotmart attribution
    url.searchParams.set('sck', sck)
    url.searchParams.set('src', sck)

    // CAPI support — _fbp and _fbc cookies
    if (fbp) url.searchParams.set('fbp', fbp)
    if (fbc) url.searchParams.set('fbc', fbc)

    return url.toString()
  } catch {
    // Fallback: always redirect to checkout even if tracking fails
    return `${HOTMART_BASE_URL}?off=${HOTMART_OFFER}`
  }
}

// ============================================
// NOTE: Meta Pixel base code is installed in index.tsx
// It fires 'PageView' on load automatically.
// ============================================

// ============================================
// META PIXEL EVENTS
// ============================================
export function trackViewContent(): void {
  try {
    if (!(window as any).fbq) return
    ;(window as any).fbq('track', 'ViewContent', {
      content_name: PRODUCT.name,
      content_type: PRODUCT.contentType,
      value: PRODUCT.value,
      currency: PRODUCT.currency,
    })
  } catch (err) {
    console.warn('[Tracking] ViewContent event failed:', err)
  }
}

export function trackAddToCart(): void {
  try {
    if (!(window as any).fbq) return
    ;(window as any).fbq('track', 'AddToCart', {
      content_name: PRODUCT.name,
      content_type: PRODUCT.contentType,
      value: PRODUCT.value,
      currency: PRODUCT.currency,
      num_items: 1,
    })
  } catch (err) {
    console.warn('[Tracking] AddToCart event failed:', err)
  }
}

// ============================================
// CHECKOUT REDIRECT (with tracking)
// ============================================
export function goToCheckout(): void {
  try {
    trackAddToCart()
  } catch {
    // Tracking failure should never block checkout
  }

  // Small delay to allow pixel event to fire, then redirect
  const url = buildCheckoutURL()
  setTimeout(() => {
    window.location.href = url
  }, 300)
}
